import { Grid } from 'antd';
import { cn } from 'cn';

export function PageBody({
    children,
    className,
    gap,
}: {
    children: React.ReactNode;
    className?: string;
    gap?: 'small' | 'big';
}) {
    const breakpoint = Grid.useBreakpoint();

    return (
        <div
            className={cn(
                breakpoint.md ? 'p-4' : 'p-2',
                gap && 'flex flex-col',
                gap === 'small' && 'gap-2',
                gap === 'big' && 'gap-4',
                className,
            )}
        >
            {children}
        </div>
    );
}
